import { render } from "./LabelButton.vue?vue&type=template&id=217e89ed&scoped=true&ts=true"
import script from "./LabelButton.vue?vue&type=script&lang=ts"
export * from "./LabelButton.vue?vue&type=script&lang=ts"

import "./LabelButton.vue?vue&type=style&index=0&id=217e89ed&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217e89ed"]])

export default __exports__